import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from "./config.service";
import { LUC } from "../interfaces/luc";
import { Multiplier } from "../interfaces/multiplier";
import { AppStateService } from '../appState.service';

@Injectable({
    providedIn: 'root'
})
export class LucsService {
    private lucs: LUC[];
    private multipliers: Multiplier[];

    constructor(
        private http: HttpClient,
        private config: ConfigService,
        private appState: AppStateService,
    ) { }

    public load(): Promise<any> {
        console.info("Loading LUCs and multipliers...");
        const language = this.appState.getLanguage();
        console.info("Current language:", language);

        return new Promise((resolve, reject) => {
            const headers = (new HttpHeaders()).append("X-No-Auth", "True");
            const mults = this.http.get(this.config.get("api.url") + "/multipliers", { headers }).toPromise();

            this.http.get(this.config.get("api.url") + `/lucs?lang=en&keys=info,name`, { headers }).subscribe(
                (data: LUC[]) => {
                    console.info("lucs", data);
                    this.lucs = data;
                    mults.then((m: Multiplier[]) => {
                        console.info("multipliers", m);
                        this.multipliers = m;

                        this.lucs.forEach(l => {
                            l.multipliers = m.find(mul => mul.zone === l.zone);
                        });

                        resolve();
                    }).catch(err => {
                        console.error("Error fetching multipliers", err);
                        reject(err);
                    });
                },
                err => {
                    console.error("Error fetching lucs", err);
                    reject(err);
                },
            );
        });
    }

    public getLUCs(): LUC[] {
        return this.lucs;
    }

    public getMults(): Multiplier[] {
        return this.multipliers;
    }
}
